export const OPENING_LINES: string[] = [
    'Всё началось с того, что...',
    'Никто не ожидал, что в этот вечер...',
    '— Ты серьёзно это сделал? — спросил он, глядя на...',
    'В холодильнике завёлся кто-то, кто...',
    'Бабушка достала из шкафа старую коробку, а там...',
    'На собеседовании кандидат вдруг сказал, что...',
    'Посреди рабочего чата кто-то написал...',
    'Сосед снизу опять постучал по трубе, потому что...',
    'В инструкции к телевизору была странная строчка...',
    'Кот запрыгнул на стол и уронил...',
    'На корпоративе кто-то включил не ту музыку, и...',
    'Водитель такси резко затормозил, потому что увидел...',
    'В посылке с маркетплейса вместо кроссовок оказался...',
    'На созвоне кто-то забыл выключить микрофон и...',
    'Дед Мороз опоздал на утренник, потому что...',
    'В лифте застряли два незнакомца, и один из них признался, что...',
    'На даче под грядкой нашли...',
    'Учительница открыла дневник и обомлела, потому что...',
    'В чат класса кто-то скинул фотографию, на которой...',
    'Гадалка посмотрела на ладонь и сказала: «У тебя...»',
];
